module.exports = __webpack_public_path__ + "uk-dff2926345923b560aa6ff16a53d6ad4.png";